module.exports = {
  cotizaData: () => {
    return{
      "IONIQ 5 EV-POWER": "https://www.hyundaicolombia.co/ioniq-5#cotizacion",
      "TUCSON HEV LIMITED": "https://hyundaicolombia.co/vehiculos/tucson-hibrida#cotizacion",
      "PALISADE SPORT": "https://www.hyundaicolombia.co/palisade#cotizacion",
      "STARIA LUJO": "https://www.hyundaicolombia.co/staria#cotizacion",
      "VENUE LIMITED AT": "https://www.hyundaicolombia.co/venue#cotizacion",
      "HB20 ADVANCE": "https://www.hyundaicolombia.co/hb20-hatchback#cotizacion",
      "HB20S ADVANCE": "https://www.hyundaicolombia.co/hb20s-sedan#cotizacion",
      "CRETA PREMIUM": "https://www.hyundaicolombia.co/creta#cotizacion",
      "KONA HEV LIMITED": "https://www.hyundaicolombia.co/kona-hibrida#cotizacion",
      "SANTA FE HEV LIMITED 4x4": "https://www.hyundaicolombia.co/santafe-hibrida#cotizacion/",

      "GRAND i10 AT PREMIUM": "https://hyundaicolombia.co/vehiculos/grand-i10#cotizacion",
      "PALISADE HEV 4x4": "https://hyundaicolombia.co/vehiculos/palisade-hibrida#cotizacion",
    }
  }
}